import { useTranslation } from 'react-i18next';

export default function WindowsEnergy() {
  const { t } = useTranslation();

  const energyStats = [
    { valKey: 'wne_stat1_val', labelKey: 'wne_stat1_label', icon: 'ri-fire-line', color: 'text-orange-500' },
    { valKey: 'wne_stat2_val', labelKey: 'wne_stat2_label', icon: 'ri-thermometer-line', color: 'text-sky-500' },
    { valKey: 'wne_stat3_val', labelKey: 'wne_stat3_label', icon: 'ri-sun-line', color: 'text-amber-500' },
    { valKey: 'wne_stat4_val', labelKey: 'wne_stat4_label', icon: 'ri-money-dollar-circle-line', color: 'text-emerald-500' },
  ];

  const comfortBenefits = [
    { icon: 'ri-volume-mute-line', titleKey: 'wne_c1_title', textKey: 'wne_c1_text' },
    { icon: 'ri-temp-cold-line', titleKey: 'wne_c2_title', textKey: 'wne_c2_text' },
    { icon: 'ri-focus-3-line', titleKey: 'wne_c3_title', textKey: 'wne_c3_text' },
    { icon: 'ri-shining-2-line', titleKey: 'wne_c4_title', textKey: 'wne_c4_text' },
  ];

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-sky-600 text-sm font-bold uppercase tracking-widest">{t('wne_tag')}</span>
          <h2 className="text-4xl md:text-5xl font-black text-slate-800 mt-3 mb-4">
            {t('wne_title1')}<br />{t('wne_title2')}
          </h2>
          <p className="text-slate-500 text-base max-w-xl mx-auto">{t('wne_desc')}</p>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
          {energyStats.map((stat) => (
            <div key={stat.labelKey} className="bg-white rounded-2xl p-7 border border-slate-100 text-center">
              <div className="w-12 h-12 bg-slate-50 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} ${stat.color} text-2xl`}></i>
              </div>
              <div className="text-2xl font-black text-slate-800 mb-1">{t(stat.valKey)}</div>
              <div className="text-slate-500 text-xs leading-tight">{t(stat.labelKey)}</div>
            </div>
          ))}
        </div>

        {/* Comfort section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="rounded-2xl overflow-hidden h-[460px]">
            <img
              src="https://public.readdy.ai/ai/img_res/dbca4b97bc02eb07ca2b9a6fbe9397c4.jpg"
              alt="Comfortable energy efficient home"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <h3 className="text-3xl font-black text-slate-800 mb-8">{t('wne_comfort_title')}</h3>
            <div className="space-y-6">
              {comfortBenefits.map((b) => (
                <div key={b.titleKey} className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-sky-50 rounded-xl flex items-center justify-center shrink-0">
                    <i className={`${b.icon} text-sky-600 text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="text-slate-800 font-bold text-sm mb-1">{t(b.titleKey)}</h4>
                    <p className="text-slate-500 text-sm leading-relaxed">{t(b.textKey)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
